import { render, staticRenderFns } from "./BCXMessengerUserSelect.vue?vue&type=template&id=683ad0e9&scoped=true"
import script from "./BCXMessengerUserSelect.vue?vue&type=script&lang=ts"
export * from "./BCXMessengerUserSelect.vue?vue&type=script&lang=ts"
import style0 from "./BCXMessengerUserSelect.vue?vue&type=style&index=0&id=683ad0e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683ad0e9",
  null
  
)

export default component.exports